import { render, staticRenderFns } from "./frmjelszovisszaallitas.vue?vue&type=template&id=10a1d143&scoped=true&"
import script from "./frmjelszovisszaallitas.vue?vue&type=script&lang=js&"
export * from "./frmjelszovisszaallitas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a1d143",
  null
  
)

export default component.exports